/**
 * Set theme on page load based on (in order of priority):
 *  1. the user's preferred theme from the theme state provider
 *  2. the user's system theme
 *  3. default to dark theme (GXPMS: 深色科技风格为默认)
 *
 * This is done outside the Angular app to avoid a flash of unthemed content before it loads.
 */
const setTheme = () => {
  /**
   * GXPMS: 默认使用深色科技风格。
   * `theme_dark` is hardcoded as the default in the web app's index.html file.
   */
  const defaultTheme = "dark";
  const htmlEl = document.documentElement;
  let theme = defaultTheme;

  const themeFromState = window.localStorage.getItem("global_theming_selection");

  if (themeFromState) {
    if (themeFromState.indexOf("system") > -1) {
      theme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    } else if (themeFromState.indexOf("light") > -1) {
      theme = "light";
    }
  }
  // GXPMS: 无用户偏好时默认深色（不跟随系统）

  if (!htmlEl.classList.contains("theme_" + theme)) {
    htmlEl.classList.remove("theme_" + (theme === "dark" ? "light" : "dark"));
    htmlEl.classList.add("theme_" + theme);
  }
};

setTheme();
